import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfigService } from '../../services/app-config.service';

import { HomeText, ListeCsp, ListeRefnasodaf } from '../models';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as country from '../country/countries-FR.json';
import { Commune } from '../models/commune.model';
import { DetailEtude } from '../models/detail-etude.model';
import { ListeLieuDit } from '../models/liste-lieu-dit.model';
import { RestService } from './rest.service';

@Injectable()
export class ObjetsService extends RestService {

  private rubriqueDOccupation = new BehaviorSubject<number>(null);
  public rubriqueDOccupation$ = this.rubriqueDOccupation.asObservable();

  private rubriqueFCheckButtonDisableG = new BehaviorSubject<boolean>(null);
  public rubriqueFCheckButtonDisableG$ = this.rubriqueFCheckButtonDisableG.asObservable();

  constructor(
    private readonly http: HttpClient
  ) {
    super();
  }


  setRubriqueDOccupation(rubriqueDOccupation: number) {
    this.rubriqueDOccupation.next(rubriqueDOccupation);
  }

  setRubriqueFCheckButtonDisableF(rubriqueFCheckButtonDisableG: boolean) {
    this.rubriqueFCheckButtonDisableG.next(rubriqueFCheckButtonDisableG);
  }

  /**
   * Webservice récupérant le texte présent sur la Home page
   *
   * @returns {Observable<HomeText>}
   */
  homeText(): Observable<HomeText> {
      return this.http.get<HomeText>(AppConfigService.settings.urlServeur + 'rest/accueil/')
              .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  /**
   * Webservice récupérant la liste des communes
   *
   * @returns {Observable<ListeCommune>}
   */
  listeCommune(): Observable<Commune[]> {
      return this.http.get<Commune[]>(AppConfigService.settings.urlServeur + 'rest/liste/commune/')
              .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  /**
   * Webservice récupérant la liste des communes
   *
   * @returns {Observable<ListeCommune>}
   */
  listeCommuneCode(): Observable<Commune[]> {
    return this.http.get<Commune[]>(AppConfigService.settings.urlServeur + 'rest/liste/communeCode/')
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  /**
   * Webservice récupérant la liste des lieux dits en fonction du code INSEE d'une commune
   *
   * @param insee
   * @returns {Observable<ListeLieuDit>}
   */
  listeLieuDit(insee): Observable<ListeLieuDit> {
    return this.http.get<ListeLieuDit>(AppConfigService.settings.urlServeur + 'rest/liste/lieuDit/?insee=' + insee)
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  /**
   * Récupère la liste des section d'une commune grâce au code insee
   *
   * @param filter
   * @returns {Observable<DetailEtude>}
   */
  listeSectionByInsee(insee) {
    return this.http.get(AppConfigService.settings.urlServeur + 'rest/liste/parcelleSectionIds/?insee=' + insee)
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  /**
   * Webservice récupératn la liste des professions
   *
   * @returns {Observable<ListeCsp>}
   */
  listeCsp(): Observable<ListeCsp> {
    return this.http.get<ListeCsp>(AppConfigService.settings.urlServeur + 'rest/liste/csp/')
        .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  /**
   * @returns {Observable<ListeRefnasodaf>}
   */
  listeRefnasodaf(): Observable<ListeRefnasodaf> {
      return this.http.get<ListeRefnasodaf>(AppConfigService.settings.urlServeur + 'rest/liste/refNasoDaf/')
              .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  /**
   * Webservice récupérant toute la liste des aliénation
   *
   * @returns {Observable<DetailEtude>}
   */
  listeAlienation(): any {
    return this.http.get(AppConfigService.settings.urlServeur + 'rest/liste/alienation/')
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  /**
   * Webservice récupérétant la liste des étude filtrée par une chaine de caratères
   *
   * @param filter
   * @returns {Observable<DetailEtude>}
   */
  listeEtudesFiltered(filter): Observable<DetailEtude> {
    return this.http.get<DetailEtude>(AppConfigService.settings.urlServeur + 'rest/liste/etudes/nom/?nom=' + filter)
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  simpleGet($url: string) {
    return this.http.get($url)
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  getOrCreate(idCerfa: number, sub: string, given_name: string, email: string) {


    const body = {
      idCerfa: idCerfa,
      teledeclarantBean: {
        sub: sub,
        given_name: given_name,
        email: email,
      }
    };

    const heads = this.createAuthorizationHeader('json');
    console.log('=========================== rest/form/getOrCreate/ ==============================');
    console.log(body);
    const url = AppConfigService.settings.urlServeur + 'rest/form/getOrCreate/';
    return this.http.post(url, JSON.stringify(body),{
      headers: heads
    })
      .catch((error: any) => {
        if (error.status !== 500) {
          return Observable.throw(error.error || 'Server error');
        } else {
          return Observable.throw('Server error 500');
        }
      });
  }

  /**
   * Récupère la liste des code Origine présente dans la base LIDIA
   *
   * @returns {any}
   */
  listeCodeOrigine(): any {
    const heads = this.createAuthorizationHeader();
    return this.http.get(AppConfigService.settings.urlServeur + 'rest/liste/codeOrigine/', {
      headers: heads
    })
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  /**
   * Récupère la liste des code Origine présente dans la base LIDIA
   *
   * @returns {any}
   */
  listeCodeOrigineEtranger(): any {
    const heads = this.createAuthorizationHeader();
    return this.http.get(AppConfigService.settings.urlServeur + 'rest/liste/codeOrigineEtranger/', {
      headers: heads
    })
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  /**
   * Récupère la liste des code Origine présente dans la base LIDIA
   *
   * @returns {any}
   */
  listeCodeOrigineDep(): any {
    const heads = this.createAuthorizationHeader();
    return this.http.get(AppConfigService.settings.urlServeur + 'rest/liste/codeOrigineDep/', {
      headers: heads
    })
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  /**
   * Webservice servant à envoyer un formulaire pour sauvegarde identifié par une idCerfa
   *
   * @param body
   * @param idCerfa
   * @returns {Observable<any>}
   */
  sendForm(body, idCerfa, sub = null) {
    let contentBean = {};
    if (body !== 'new') {
      contentBean = body;
    }

    const constructBody = {
      'idCerfa': idCerfa,
      'contentBean': contentBean,
      'sub': sub
    };

    if (sub === null) {
      constructBody.sub = '';
    }
    console.log(JSON.stringify(constructBody));
    const heads = this.createAuthorizationHeader('json');
    const url = AppConfigService.settings.urlServeur + 'rest/form/save/';
    return this.http.post(url, JSON.stringify(constructBody), {headers: heads})
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  /**
   * Webservice validant le formulaire identifié par l'idCerfa
   *
   * @param idCerfa
   * @returns {Observable<any>}
   */
  validationForm(body, idCerfa) {

    const constructBody = {
      'idCerfa': idCerfa,
      'contentBean': body,
    };

    const heads = this.createAuthorizationHeader('json');
    const url = AppConfigService.settings.urlServeur + 'rest/form/validate/';
    return this.http.post(url, JSON.stringify(constructBody),{
      headers: heads
    })
      .catch((error: any) => {
        if (error.status !== 500) {
          return Observable.throw(error.error || 'Server error');
        } else {
          return Observable.throw('Server error 500');
        }
      });
  }

  /**
   * Webservice de connexion à lidia par  franceConnect
   *
   * @param body
   * @returns {Observable<any>}
   */
  saveFcUser(body) {
    const heads = this.createAuthorizationHeader('json');
    const url = AppConfigService.settings.urlServeur + 'rest/form/connect/';
    return this.http.post(url, JSON.stringify(body), {headers: heads})
      .catch((error: any) => {
        console.error(error);
        return Observable.throw(error.error || 'Server error');
      });
  }

  /**
   * Webservice récupérant un nouvel idCefa en fonction du sub de l'utilisateur
   *
   * @param idFile
   * @param idCerfa
   * @returns {Observable<any>}
   */
  createForm(sub) {
    const heads = this.createAuthorizationHeader();
    const url = AppConfigService.settings.urlServeur + 'rest/form/create/?sub=' + sub;
    return this.http.get(url, {
      headers: heads
    })
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  getCountry() {
    return country;
  }

  /**
   * Récupère la liste des code Origine présente dans la base LIDIA
   *
   * @returns {any}
   */
  printPDFCerfa(idCerfa: number): any {
    const url = AppConfigService.settings.urlServeur + 'rest/form/file/cerfa/?idCerfa=' + idCerfa;
    window.open(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/objets.service.ts